import axios from 'axios'

export default {
  namespaced: true,
  state: {
    open: 0,
    openPrima: 0,
    items: [],
    item: {}
  },

  getters: {
    items (state) {
      return state.items || []
    },
    item (state) {
      return state.item || {}
    },
    open (state) {
      return state.open || {}
    },
    openPrima (state) {
      return state.openPrima || {}
    }
  },

  mutations: {
    setOpen (state, value) {
      state.open = value || 0
    },
    setItems (state, value) {
      state.items = value || []
    },
    setItem (state, value) {
      state.item = value || {}
    },
    setOpenPrima (state, value) {
      state.openPrima = value || 0
    }
  },

  actions: {
    async loadItems ({ commit }, criterio) {
      try {
        // console.log('messages/loadItems criterio', criterio)
        let rs = await axios.get('/api/messages', { params: { op: criterio } })
        commit('setItems', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadPrimaVisione ({ commit }) {
      try {
        let rs = await axios.get('/api/messages', { params: { op: 'primaVisione' } })
        commit('setItems', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadItemById ({ commit }, id) {
      try {
        let rs = await axios.get(`/api/messages/${id}`)
        // console.log('/api/messages/id', rs, rs.data, rs.data.count)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async countOpen ({ commit }) {
      try {
        let rs = await axios.get(`/api/messages`, { params: { op: 'contaAperte' } })
        // console.log('/api/messages contaAperte', rs.data, rs.data.count)
        commit('setOpen', rs.data.count)
      } catch (err) {
        throw err
      }
    },
    async countPrimaVisione ({ commit }) {
      try {
        let rs = await axios.get(`/api/messages`, { params: { op: 'contaApertePrima' } })
        // console.log('/api/messages contaApertePrima', rs.data, rs.data.count)
        commit('setOpenPrima', rs.data.count)
      } catch (err) {
        throw err
      }
    },
    async confermaLettura ({ commit }, item) {
      try {
        let rs = await axios.put(`/api/messages/${item.id}/conferma`, item)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async confermaVisione ({ commit }, item) {
      try {
        let rs = await axios.put(`/api/messages/${item.id}/confermaVisione`, item)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async archivia ({ commit }, item) {
      try {
        let rs = await axios.put(`/api/messages/${item.id}/archivia`, item)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    }
  }
}
